import { render } from "./cp_record_major.vue?vue&type=template&id=72ee16ac&scoped=true"
import script from "./cp_record_major.vue?vue&type=script&lang=js"
export * from "./cp_record_major.vue?vue&type=script&lang=js"

import "./cp_record_major.vue?vue&type=style&index=0&id=72ee16ac&scoped=scoped&lang=css"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ee16ac"]])

export default __exports__